import { render } from "./tabsComponent.vue?vue&type=template&id=531a678c&scoped=true"
import script from "./tabsComponent.vue?vue&type=script&lang=js"
export * from "./tabsComponent.vue?vue&type=script&lang=js"

import "./tabsComponent.vue?vue&type=style&index=0&id=531a678c&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a678c"]])

export default __exports__